import styled from 'styled-components';
import rtl from 'styled-components-rtl';

export const StyledPropertyPortalWrapper = styled.div`
${rtl`
    body {
        overflow: 'hidden';
    }
    div {
        width: unset;
        height: unset;
    }

    /* Centre the modal on mobile — override the default bottom-anchored sheet behaviour */
    > div > div {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        bottom: unset;
        width: 90%;
        max-width: 90%;
        border-radius: 0.875rem;
        margin: unset;
        background: none;
        box-shadow: none;
    }
`}
`;
